import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { testId } from 'ui-components/services/testid-service';

import Global from '../../../../store/global-selectors';
import { loadMoreLabelQueBatches } from '../../../../store/label-que/label-que.actions';
import style from './style.module.less';

const hasFetchedState = (onFetchOlderBatches) => {
  return (
    <React.Fragment>
      <div className={style.header}>
        <FormattedMessage defaultMessage='Your Queue is empty!' description='labelEmptyQue.header' id='Vaciap' />
      </div>
      <div className={style.supplement}>
        <FormattedMessage
          defaultMessage='Recent, unarchived labels will show up here.'
          description='labelEmptyQue.supplement'
          id='Z7q5nR'
        />
      </div>
      <div className={style.loader}>
        <Button onClick={onFetchOlderBatches} theme='link'>
          <FormattedMessage defaultMessage='load older labels..' description='labelEmptyQue.loader' id='gG8KmB' />
        </Button>
      </div>
    </React.Fragment>
  );
};

export const EmptyQuePlaceholder = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(Global.selectLabelQueIsLoading);

  const onFetchOlderBatches = useCallback(() => {
    dispatch(loadMoreLabelQueBatches());
  }, [dispatch]);

  return (
    <div className={style['empty-que-wrapper']} {...testId('empty-que-wrapper')}>
      {isLoading && <LoadingIndicator className={style['que-loading-indicator']} />}
      {!isLoading && hasFetchedState(onFetchOlderBatches)}
    </div>
  );
};
